import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@weave-mui/styles';
import CssBaseline from '@weave-mui/cssbaseline';
import { store } from './store/store';
import { queryClient } from './query/queryClient';
import { router } from './routes';
import ErrorBoundary from './components/ErrorBoundary';
import { loadAppTheme } from './theme';
const App = () => {
    const [theme, setTheme] = useState(null);
    const [themeInitialized, setThemeInitialized] = useState(false);
    const [themeError, setThemeError] = useState(null);
    useEffect(() => {
        let cancelled = false;
        loadAppTheme()
            .then((t) => {
            if (!cancelled) {
                setTheme(t);
                setThemeInitialized(true);
            }
        })
            .catch((err) => {
            if (!cancelled) {
                setThemeError(err);
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    if (themeError) {
        return (_jsxs("div", { style: { padding: 24, fontFamily: 'sans-serif' }, children: [_jsx("h2", { children: "Failed to load design theme" }), _jsx("p", { children: themeError.message })] }));
    }
    if (!themeInitialized || !theme)
        return null;
    return (_jsx(ErrorBoundary, { children: _jsx(Provider, { store: store, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(RouterProvider, { router: router })] }) }) }) }));
};
export default App;
